<div class="processing-dismiss-dialog">
    <!-- Parts ordering session header -->
    <div class="processing-dismiss-dialog-header flex-between-center">
      <div class=" flex-start-center font-bold">
          {{headingTitle}}
      </div>
  
      <span class="close-modal">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </span>
    </div>
  
    <div class="processing-dismiss-dialog-body">
        <div class="processing-done">
          <div class="flex-center-center" *ngIf="isLoading">
            <i class="fal fa-spinner rotate loader font-primary"></i>
          </div>
          <div class="flex-center-center" *ngIf="isSuccess">
            <i class="fal fa-check-circle loader font-primary"></i>
          </div>
        </div>
  
        <p class="mb-0 availability-message mt-4">
            {{message}}
        </p>
    </div>
  </div>
  